"use strict";

var LoggerInstance = require("js-logger").get("TabStore");

var AbstractStore = require("./AbstractStore");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var state = {
	isDesignMode: false
};

var TabStore = class extends AbstractStore {
	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}
};

TabStore.dispatchToken = Dispatcher.register(function (action) {
	switch (action.actionType) {
		case Constants.TABS_INITIALIZE:
			state.isDesignMode = action.isDesignMode;
			return true; // Don't emit change

		default:
			// no op
			return true;
	}

	TabStore.emitChange();
	return true;
});

module.exports = new TabStore();
